import React, { useState } from "react";

import GamificationPointsTab from "./components/points";
import GamificationRewardsTab from "./components/rewards";
import { TabBar } from "src/components/tabbar";

import cx from "classnames";
import styles from "./gamification.module.scss";

export type GamificationSettingsTab = "points" | "rewards";

export const GamificationSettingsPage: React.FC<object> = () => {
  const [activeTab, setActiveTab] = useState<GamificationSettingsTab>("points");

  const activeIndex = activeTab === "points" ? 0 : 1;

  return (
    <section className={styles.container}>
      <div className={styles.pageHeader}>
        <div className={cx(styles.header)}>
          <h1 className={cx(styles.title)}>Gamification</h1>
          <p className={styles.subtext}>
            Boost learner engagement through points, rewards, and recognition.
          </p>
        </div>
      </div>

      <div className={styles.tabContainer} role="tablist">
        <TabBar
          className={styles.tabs}
          gap={32}
          active={activeIndex}
          onSelectionChange={(index) => setActiveTab(index === 0 ? "points" : "rewards")}
        >
          <div role="tab" aria-selected={activeTab === "points"} className={cx(styles.tab, activeTab === "points" && styles.active)}>Points</div>
          <div role="tab" aria-selected={activeTab === "rewards"} className={cx(styles.tab, activeTab === "rewards" && styles.active)}>Rewards</div>
        </TabBar>
      </div>

      {activeTab === "points" && <GamificationPointsTab />}
      {activeTab === "rewards" && <GamificationRewardsTab />}
    </section>
  );
};
